import {Utils} from 'hasta-la-vista-ui-core'
import {AuthService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
  name: 'passwordreset',
  data() {
    return {
      loading:false,
      loadingReset: false,
      codeVerified: null,
      passwordReset: null,
      userEmail: '',
      newPassword: '',
      emailsent: false,
      disabled: 0,
      showPasswordForm: false,
      //this needs to be verified by the backend before the new password field is shown
      resetCodeUrl: this.$route.params.resetCode,
      memberId:'',
      toastChecked: false,
      noEmailDialog: false
    }
  },
  methods: {
    //verify the resetcode in the url
    verifyCode: function(resetCode) {

      //sample:a1231160-552e-41ea-99ae-1f26a11879da
      if(resetCode !== 'email' && resetCode.length === 36) {
        this.loading = true;
        //verify the password reset code with the middleware
        Promise.resolve(ApiHttp.post(url + 'verify-password-reset-code', {
          reset_code: this.$route.params.resetCode,
        })).then(res => {
          if(res.status) {
            this.codeVerified = res;
            this.memberId = res.data.MemberId;
          }else{

            // this.$toaster.show(res.errors[0], {
            //   top: true,
            //   timeout: 5000,
            //   fullscreen: true,
            //   primary: true
            // });
          }
          this.loading = false;
        })

      }
    },

    initiatePasswordReset(userEmail) {
      if(!this.disabled) {
        this.loadingReset = true;
        this.disabled = 1;
        let refUrl = document.location.hostname;
        let refPort = document.location.port;
        if(refPort > 0) {
          refUrl = document.location.hostname + ":" + document.location.port;
        }
        Promise.resolve(AuthService.initiatePasswordReset(userEmail)).then(data => {
            // console.log(data)
          if(!data.data.MemberNotFound) {

            this.emailsent = true
            this.userEmail = userEmail
            //this.$toaster.show('We sent a message to ' + userEmail + ' so you can pick your new password. Please click on the link in your email to create your new password.');

          } else {
            // if (!this.toastChecked) {
            //   this.$toaster.show('Whoops! This email does not exist on our site. Please <a href="/user/signup">create a profile</a>.', {
            //     top: true,
            //     timeout: null,
            //     fullwidth: true,
            //     primary: true
            //   });
            // }
            this.noEmailDialog = true
            this.disabled = 0;
          }
          this.loadingReset = false;
        });
      }
    },

    completePasswordReset(newPassword, resetToken) {

      if(!this.disabled) {
        this.loadingReset = true;
        this.disabled = 1;
        Promise.resolve(ApiHttp.post(url + 'complete-password-reset', {
          new_password: newPassword,
          reset_token: resetToken,
          member_id: this.memberId,
        })).then(data => {
          if(data.status || this.resetCodeUrl === 'dev') {
            window.location.href = ('/user/reset')
          } else {
            this.disabled = 0;
            // this.$toaster.show('Something went wrong');
          }
          this.loadingReset = false;
        });
      }
    }
  },

  mounted() {
    this.verifyCode(this.resetCodeUrl);
    // console.log(this.isRequestCard)
  },

  computed: {
    isRequestCard() {
      if (this.$route.name === 'requestcard') return true
      else return false
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/user/password-reset.js